import { render } from "./loaderComponent.vue?vue&type=template&id=3d87df76&scoped=true"
import script from "./loaderComponent.vue?vue&type=script&lang=js"
export * from "./loaderComponent.vue?vue&type=script&lang=js"

import "./loaderComponent.vue?vue&type=style&index=0&id=3d87df76&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d87df76"]])

export default __exports__